import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, IdentityProvider } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  identityProviders: Identifiable<IdentityProvider>[];
  retrieveIdentityProviders(
    request: Boundaries["retrieveIdentityProviders"]["request"],
  ): void;
}

function useRetrieveIdentityProviders(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveIdentityProvidersRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveIdentityProvidersRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveIdentityProvidersRequestFailure,
    ),
    identityProviders: useSelector(selector.getIdentityProviders),
    retrieveIdentityProviders: core.retrieveIdentityProviders,
  };
}

export { useRetrieveIdentityProviders };
